(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  (function () {
    if (window.__mayoreoEstimateInit) return;
    window.__mayoreoEstimateInit = true;

    function parseMoney(text) {
      if (!text) return null;
      var match = String(text).match(/-?\d[\d.,]*/);
      if (!match) return null;
      var raw = match[0].replace(/,/g, '');
      var value = parseFloat(raw);
      return isNaN(value) ? null : value;
    }

    function formatMoney(value) {
      var negative = value < 0;
      var abs = Math.abs(value);
      var formatted = abs.toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      return (negative ? '-' : '') + '$ ' + formatted + ' mxn';
    }

    function getDrawerRoot() {
      return document.getElementById('CartDrawer') || document;
    }

    function findExactDiscountedTotal() {
      var el = getDrawerRoot().querySelector('[data-hulkapps-cart-total], .hulkapps-cart-total');
      if (!el) return null;
      return parseMoney(el.textContent);
    }

    var HULK_MSG_SELECTOR = [
      '.hulkapps-cart-reminder',
      '.hulkapps-discount-reminder-msg',
      '.hulkapps-discount-bar',
      '.hulkapps-discount-bar-msg',
      '[class*="hulkapps"][class*="reminder"]',
      '[class*="hulkapps"][class*="discount-bar"]',
    ].join(', ');

    function findVisibleSavings() {
      var candidates = getDrawerRoot().querySelectorAll(HULK_MSG_SELECTOR);
      for (var i = 0; i < candidates.length; i++) {
        var text = candidates[i].textContent || '';
        var moneyMatch = text.match(/\$\s?-?[\d,]+(?:\.\d{1,2})?/);
        if (moneyMatch) {
          var value = parseMoney(moneyMatch[0]);
          if (value !== null && value > 0) return value;
        }
      }
      return null;
    }

    var isUpdating = false;

    function updateMayoreoEstimate() {
      if (isUpdating) return;
      isUpdating = true;
      try {
        var subtotalEl = document.querySelector('.totals__subtotal-value[data-cart-subtotal-cents]');
        var totalRow = document.querySelector('[data-mayoreo-total-row]');
        var totalValueEl = document.querySelector('[data-mayoreo-total-value]');
        var noteEl = document.querySelector('[data-mayoreo-note]');
        if (!subtotalEl || !totalRow || !totalValueEl || !noteEl) return;

        var subtotalCents = parseInt(subtotalEl.getAttribute('data-cart-subtotal-cents'), 10);
        var subtotal = isNaN(subtotalCents) ? 0 : subtotalCents / 100;

        var savings = null;

        if (subtotal > 0) {
          var exactTotal = findExactDiscountedTotal();
          if (exactTotal !== null && exactTotal > 0 && exactTotal < subtotal) {
            savings = subtotal - exactTotal;
          } else {
            savings = findVisibleSavings();
          }
        }

        if (savings === null || savings <= 0 || savings >= subtotal) {
          if (!totalRow.hidden) totalRow.hidden = true;
          if (!noteEl.hidden) noteEl.hidden = true;
          if (totalValueEl.textContent !== '') totalValueEl.textContent = '';
          if (noteEl.textContent !== '') noteEl.textContent = '';
          return;
        }

        var estimatedTotal = subtotal - savings;
        var totalText = formatMoney(estimatedTotal);
        var noteText = 'El descuento definitivo se aplicará y confirmará en checkout.';

        if (totalValueEl.textContent !== totalText) totalValueEl.textContent = totalText;
        if (noteEl.textContent !== noteText) noteEl.textContent = noteText;
        if (totalRow.hidden) totalRow.hidden = false;
        if (noteEl.hidden) noteEl.hidden = false;
      } finally {
        isUpdating = false;
      }
    }

    var debounceTimer = null;
    function scheduleUpdate() {
      if (debounceTimer) clearTimeout(debounceTimer);
      debounceTimer = setTimeout(updateMayoreoEstimate, 200);
    }

    var drawerObserver = null;
    function attachDrawerObserver() {
      if (drawerObserver) return;
      var root = document.getElementById('CartDrawer');
      if (!root) return;
      drawerObserver = new MutationObserver(scheduleUpdate);
      drawerObserver.observe(root, { childList: true, subtree: true, characterData: true });
    }

    var pubsubSubscribed = false;
    function subscribeCartPubsub() {
      if (pubsubSubscribed) return;
      if (!window.FoxTheme || !window.FoxTheme.pubsub || !window.FoxTheme.pubsub.PUB_SUB_EVENTS) return;
      FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, scheduleUpdate);
      pubsubSubscribed = true;
    }

    document.addEventListener('cart:refresh', scheduleUpdate);
    document.addEventListener('cart:updated', scheduleUpdate);

    function init() {
      attachDrawerObserver();
      subscribeCartPubsub();
      scheduleUpdate();

      if (!pubsubSubscribed) {
        var tries = 0;
        var retry = setInterval(function () {
          tries++;
          subscribeCartPubsub();
          if (pubsubSubscribed || tries > 50) clearInterval(retry);
        }, 100);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
